module.exports = __webpack_public_path__ + "img/valve-loop-switching.16010aa9.svg";